import React from "react";
import { ArrowRight } from "lucide-react";

const ROW_BASE = "w-full text-left px-4 py-2.5 flex items-center gap-3";
const ROW_ACTIVE = "bg-[#FFF8E7] dark:bg-slate-800";
const ROW_HOVER = "hover:bg-slate-50 dark:hover:bg-slate-800/60";

export function ResultsHeader({ icon: Icon, label }) {
  return (
    <div className="px-4 pt-3 pb-1 text-[10px] uppercase tracking-wider font-bold text-[#475569] dark:text-slate-500 flex items-center gap-1.5">
      {Icon ? <Icon className="w-3 h-3" /> : null} {label}
    </div>
  );
}

export function ResultRow({ icon: Icon, primary, secondary, active, onSelect, onHover, testId }) {
  return (
    <button
      onMouseEnter={onHover}
      onClick={onSelect}
      data-testid={testId}
      className={`${ROW_BASE} ${active ? ROW_ACTIVE : ROW_HOVER}`}
    >
      <Icon className="w-4 h-4 text-[#C9A356] shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm text-[#0A2540] dark:text-white truncate">{primary}</div>
        <div className="text-xs text-[#475569] dark:text-slate-400 truncate">{secondary}</div>
      </div>
      <ArrowRight className="w-3.5 h-3.5 text-[#94A3B8] shrink-0" />
    </button>
  );
}

export function QuickLinkRow({ label, active, onSelect, onHover, testId }) {
  return (
    <button
      onMouseEnter={onHover}
      onClick={onSelect}
      data-testid={testId}
      className={`${ROW_BASE} ${active ? ROW_ACTIVE : ROW_HOVER}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#C9A356] shrink-0"></span>
      <span className="text-sm text-[#0A2540] dark:text-white">{label}</span>
      <ArrowRight className="w-3.5 h-3.5 text-[#94A3B8] ml-auto" />
    </button>
  );
}

export function EmptyResults({ q }) {
  return (
    <div className="px-4 py-12 text-center text-sm text-[#475569] dark:text-slate-400">
      No matches for "<span className="font-medium text-[#0A2540] dark:text-white">{q}</span>"
    </div>
  );
}

export function FooterHints() {
  return (
    <div className="border-t border-[#E2E8F0] dark:border-slate-700 px-4 py-2 flex items-center gap-4 text-[10px] text-[#475569] dark:text-slate-500">
      <span>↑↓ navigate</span>
      <span>↵ open</span>
      <span className="ml-auto">Press <kbd className="px-1 rounded bg-slate-100 dark:bg-slate-800 font-mono">⌘K</kbd> to toggle</span>
    </div>
  );
}
